import { useTranslation } from 'react-i18next';
import MainTitle from '../common/MainTitle';
import Icon from '../common/Icon';

import { getApplyParamters } from '../../js/utils/paramters';
import { useCookies } from 'react-cookie';
import useNavigationWithQuery from '../../hooks/useNavigationWithQuery';
import ImageLink from '../../js/utils/ImageLink';

export default function HeroSection({ image1, image2 }) {
  const { t } = useTranslation(['AdmissionsPage']);
  const { queryParams } = useNavigationWithQuery();
  const [cookies] = useCookies();

  return (
    <section className="hero-section container">
      {image1 && (
        <div className="hero-section__secondary-media">
          <picture>
            <source srcSet={ImageLink(image1?.url)} type="image/webp" />
            <img src={ImageLink(image1?.url)} alt={image1?.alt} />
          </picture>
        </div>
      )}

      <div className="hero-section__content">
        <MainTitle type="dark" className="text--2xl hidden--lg">
          <span>{t('readyToJoin')}</span>
          <span className="decorated-line decorated-line--dark decorated-line--left">
            {t('futureLeadership')}
          </span>
        </MainTitle>

        <div className="hero-section__content-container">
          <MainTitle type="dark" className="text--2xl hidden--md">
            <span>{t('readyToJoin')}</span>
            <span className="decorated-line decorated-line--dark decorated-line--left">
              {t('futureLeadership')}
            </span>
          </MainTitle>

          <a
            href={`https://manaraschool.heiapply.com/application/main_school?${getApplyParamters(
              cookies,
              queryParams
            )}`}
            target="_blank"
            className="button app-button app-button--dark"
            rel="noreferrer">
            <span />
            <span>{t('startYourApplication')}</span>
          </a>
        </div>

        <div className="hero-section__main-media"></div>
      </div>
    </section>
  );
}
